export default {
  allSchedules: [],
  calenderSchedules : [],
  isCaledarLoad : false
};
